import { UserAccount, UserPreferences } from '@iot-platform/models/common';
import { Observable } from 'rxjs';

export abstract class AbstractUserPreferencesFavoriteFilterEngineService {
  abstract getAccount$(): Observable<UserAccount>;

  abstract getUserPreferences$(): Observable<UserPreferences>;

  abstract saveUserPreferences(preferences: UserPreferences): void;
}
